import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Table from "@mui/material/Table";
import SettingsIcon from "@mui/icons-material/Settings";
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { visuallyHidden } from "@mui/utils";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import { alpha } from "@mui/material/styles";
import { TableSortLabel, Toolbar, Typography } from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../axiosClient";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "#",
    numeric: true,
    label: "#",
  },
  {
    id: "email",
    numeric: false,
    label: "Email",
  },
  {
    id: "customer_billing",
    numeric: true,
    label: "Customer billing system id",
  },
  {
    id: "store_name",
    numeric: false,
    label: "Store name",
  },
  {
    id: "reseller",
    numeric: false,
    label: "Reseller",
  },
  {
    id: "type",
    numeric: false,
    label: "Type",
  },
  {
    id: "go",
    numeric: false,
    label: "Go to the shop",
  },
  {
    id: "change name",
    numeric: false,
    label: "Change store name",
  },
  {
    id: "clear",
    numeric: false,
    label: "Clear Invoices",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            style={{ padding: "4px" }}
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <>
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            Customers
          </Typography>
          <TextField
            label="Search"
            sx={{ marginRight: 8 }}
            size="small"
            value={props.searchQuery}
            onChange={(e) => props.setSearchQuery(e.target.value)}
          />
        </>
      )}
    </Toolbar>
  );
}

export default function CustomersScreen() {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("email");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [rows, setRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [dialogData,setDialogData] = useState({});
  const [newName,setNewName] = useState();
  const [thePassword, setThePassword] = useState();
  const [modalClearOpen,setModalClearOpen] =useState(false);
  const [dialogClearData,setDialogClearData] = useState({});

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleCloseClear = () => {
    setModalClearOpen(false);
  };

  const filteredData = rows.filter(
    (item) =>
      item.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.store.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.cust_bill_id.toString().includes(searchQuery) ||
      item.store.resellerCode ===
        (searchQuery.toLowerCase() === "softech"
          ? 1
          : searchQuery.toLowerCase() === "softtouch"
          ? 2
          : searchQuery.toLowerCase() === "softeleia"
          ? 3
          : searchQuery.toLowerCase() === "nikitas"
          ? 4
          : searchQuery.toLowerCase() === "runstop"
          ? 5
          : searchQuery.toLowerCase() === "coama"
          ? 6
          : searchQuery.toLowerCase() === "tomas"
          ? 7
          : searchQuery.toLowerCase() === "restus"
          ? 8
          : null)
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredData, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filteredData]
  );

  const location = useLocation();
  const navigate = useNavigate();
  const { id, name } = location.state || {};

  useEffect(() => {
    if (id && id === 1 && name === "SOFTECH") {
      axiosClient
        .get(`${process.env.REACT_APP_BASE_URL}auth/adminallcustomers`)
        .then((allCustomerData) => {
          const data = allCustomerData.data.data.flatMap((obj) =>
            obj.Companies.flatMap((company) =>
              company.Stores.map((store) => ({
                storeName: store.name,
                cust_bill_id: obj.cust_bill_id,
                email: obj.email,
                store: store,
              }))
            )
          );
          setRows(data);
        });
    } else if (id) {
      axiosClient
        .get(`${process.env.REACT_APP_BASE_URL}auth/allcustomers/${id}`)
        .then((allCustomerData) => {
          const data = allCustomerData.data.data.flatMap((obj) =>
            obj.Companies.flatMap((company) =>
              company.Stores.map((store) => ({
                storeName: store.name,
                cust_bill_id: obj.cust_bill_id,
                email: obj.email,
                store: store,
              }))
            )
          );
          setRows(data);
        });
    } else {
      navigate("/");
    }
  }, []);

  const handleLogin = (email, store) => {
    const payload = {
      params: {
        email: email,
      },
    };

    axiosClient
      .get("auth/adminLoginWithCustomerEmail", payload)
      .then((response) => {
        window.open(
          `${process.env.REACT_APP_TO_URL}login/?token=${
            response.data.accessToken
          }&store=${encodeURIComponent(JSON.stringify(store))}`,
          "_blank"
        );
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Full height to vertically center
        backgroundColor: "#f0f0f0", // Optional background for the box
      }}
    >
      <Paper sx={{ width: "75%", mb: 2 }}>
        <EnhancedTableToolbar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
        />
        <Dialog
          open={modalOpen}
          onClose={handleClose}
        >
          <DialogTitle>Change store name</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To change the store name please enter the new name here.
            </DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              name="name"
              label="Store name"
              type="name"
              fullWidth
              onChange={(e) =>{
                setNewName(e.target.value)
              }}
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={() => {
              if(newName != null){
                const payload = {
                  oldName: dialogData.oldName,
                  newName: newName,
                  id: dialogData.id
                }

                axiosClient.post('changeStoreName/',payload)
                .then(()=>{
                  setDialogData({});
                  setNewName(null);
                  window.location.reload();
                  setModalOpen(false);
                }).catch((err) => console.log(err))
              }
            }}>Change</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={modalClearOpen}
          onClose={handleCloseClear}
        >
          <DialogTitle>Clear store invoices</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Clear the invoices of a store.
            </DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              id="password"
              name="password"
              label="Password"
              type="password"
              fullWidth
              onChange={(e) =>{
                setThePassword(e.target.value)
              }}
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseClear}>Cancel</Button>
            <Button onClick={() => {
              if(thePassword == 150194){
                const payload = {
                  oldName: dialogClearData.oldName,
                  id: dialogClearData.id
                }

                axiosClient.post('clearInvoices/clear',payload)
                .then(()=>{
                  setDialogClearData({});
                  setThePassword(null);
                  window.location.reload();
                  setModalClearOpen(false);
                }).catch((err) => console.log(err))
              }
            }}>Clear</Button>
          </DialogActions>
        </Dialog>
        <TableContainer
          component={Paper}
          sx={{
            width: "100%", // Adjust the width to a smaller percentage
            backgroundColor: "white", // Ensure table has a white background
          }}
        >
          <Table sx={{ minWidth: 400 }} size="small" aria-label="simple table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {visibleRows.map((row, index) => (
                <TableRow
                  key={index + 1}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    cursor: "pointer",
                  }}
                >
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center">
                    <b>{row.cust_bill_id}</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>{row.storeName}</b>
                  </TableCell>
                  <TableCell align="center">
                    {row.store.resellerCode === 1
                      ? "SOFTECH"
                      : row.store.resellerCode === 2
                      ? "SOFTTOUCH"
                      : row.store.resellerCode === 3
                      ? "SOFTELEIA"
                      : row.store.resellerCode === 4
                      ? "NIKITAS"
                      : row.store.resellerCode === 5
                      ? "RUNSTOP"
                      : row.store.resellerCode === 6
                      ? "COAMA"
                      : row.store.resellerCode === 7
                      ? "TOMAS"
                      : "RESTUS"}
                  </TableCell>
                  <TableCell align="center">
                    {row.store.id === 8 ||
                    row.store.id === 21 ||
                    row.store.id === 22 ||
                    row.store.id === 23 ||
                    row.store.id === 24 ||
                    row.store.id === 25 ||
                    row.store.id === 26
                      ? "RESELLER ACCOUNT"
                      : "CUSTOMER ACCOUNT"}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => handleLogin(row.email, row.store)}
                      color="success"
                      aria-label="forward"
                    >
                      <ArrowForwardIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => {
                        setModalOpen(true);
                        setDialogData({
                          id: row.store.id,
                          oldName: row.storeName,
                        })
                      }}
                      color="info"
                      aria-label="forward"
                    >
                      <SettingsIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() => {
                        setModalClearOpen(true);
                        setDialogClearData({
                          id: row.store.id,
                          oldName: row.storeName,
                        })
                      }}
                      color="error"
                      aria-label="forward"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 33 * emptyRows,
                  }}
                >
                  <TableCell colSpan={13} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
